export const LOGO_CONSTRAINTS = {
  maxBytes: 2 * 1024 * 1024, // 2MB
  acceptedTypes: ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'],
  acceptedExtensions: ['.png', '.jpg', '.jpeg', '.svg'],
}

function hasAcceptedExtension (fileName) {
  const name = String(fileName || '').toLowerCase()
  return LOGO_CONSTRAINTS.acceptedExtensions.some((ext) => name.endsWith(ext))
}

export function fileToDataUrl (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error('Failed to read image file'))
    reader.readAsDataURL(file)
  })
}

export function validateLogoFile (file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Please select an image file'))
      return
    }

    const typeOk = LOGO_CONSTRAINTS.acceptedTypes.includes(file.type)
    const extensionOk = hasAcceptedExtension(file.name)

    if (!typeOk && !extensionOk) {
      reject(new Error('Image must be a PNG, JPG/JPEG, or SVG file'))
      return
    }

    if (file.size > LOGO_CONSTRAINTS.maxBytes) {
      reject(new Error('Image must be 2MB or smaller'))
      return
    }

    resolve(true)
  })
}
